import React, { FC, useMemo } from 'react';

import { DEFAULT_BUBBLE } from './constants';
import { rand } from './helpers';
import { BubbleConfig, BubblesProps } from './models';

import './Bubbles.scss';

const Bubbles: FC<BubblesProps> = ({
  count = 40,
  spriteSrc = DEFAULT_BUBBLE,
  minSize = 10,
  maxSize = 80,
  minDur = 8,
  maxDur = 18,
}) => {
  const bubbles: BubbleConfig[] = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => {
        const size = Math.round(rand(minSize, maxSize));
        const scale = size / 64;

        return {
          id: i,
          sizePx: size,
          xVw: rand(-5, 105),
          driftPx: rand(-80, 80),
          durSec: rand(minDur, maxDur),
          delaySec: rand(0, 10),
          rotStartDeg: rand(-30, 30),
          rotDeltaDeg: rand(30, 100),
          opacity: rand(0.25, 1),
          scale,
        };
      }),
    [count, minSize, maxSize, minDur, maxDur]
  );

  return (
    <div className="bubbles" aria-hidden="true">
      {bubbles.map((b) => (
        <img
          key={b.id}
          className="bubble"
          src={spriteSrc}
          alt=""
          style={
            {
              '--size': `${b.sizePx}px`,
              '--x': `${b.xVw}`,
              '--drift': `${b.driftPx}px`,
              '--dur': `${b.durSec}s`,
              '--delay': `${b.delaySec}s`,
              '--rotStart': `${b.rotStartDeg}deg`,
              '--rotDelta': `${b.rotDeltaDeg}deg`,
              '--opacity': `${b.opacity}`,
              '--scale': `${b.scale}`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};

export default Bubbles;
